export const isNumeric = (maybeNumber: string | null | undefined): boolean => {
  // Number(0) and Number('') return 0
  if (maybeNumber === null || maybeNumber === '') {
    return false;
  }

  return !Number.isNaN(Number(maybeNumber));
};
